import React from 'react';
import { Col, Row } from 'reactstrap';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Components
import TextField from '../../../components/TextField/TextField';
export default function Estabelecimento({ estabelecimento, setEstabelecimento }) {
    //OnChange dos campos
    const onChangeEstabelecimento = (e, select) => {
        if (select && select.name) {
            setEstabelecimento({
                ...estabelecimento,
                [select.name]: e,
            })
        } else {
            const { name, value } = e.target;
            setEstabelecimento({
                ...estabelecimento,
                [name]: value,
            })
        }
    }

    //Opções do select de horarios de funcionamento
    const condicoesHorarioFuncionamento = [
        { text: "Selecione", value: "" },
        { text: "24 Horas", value: "24 Horas" },
        { text: "Diurno", value: "Diurno" },
        { text: "Noturno", value: "Noturno" },
        { text: "Emergência", value: "Emergência" },
    ]

    //Opções do select de condições de funcionamento
    const condicoesFuncionamento = [
        { text: "Selecione", value: "" },
        { text: "Em atividade", value: "Em atividade" },
        { text: "Em implantação", value: "Em implantação" },
        { text: "Em expansão / modernização", value: "Em expansão / modernização" },
        { text: "Em relocalização", value: "Em relocalização" },
    ]

    //Opções para o select de dias de funcionamento
    const diasFuncionamento = [
        { label: "Domingo", value: "Domingo" },
        { label: "Segunda-Feira", value: "Segunda-Feira" },
        { label: "Terça-Feira", value: "Terça-Feira" },
        { label: "Quarta-Feira", value: "Quarta-Feira" },
        { label: "Quinta-Feira", value: "Quinta-Feira" },
        { label: "Sexta-Feira", value: "Sexta-Feira" },
        { label: "Sábado", value: "Sábado" },
    ]

    //Opções para o select de rotina de bioseguranca
    const rotinaBioSeguranca = [
        { text: "Selecione", value: "" },
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
        { text: "Em fase de elaboração", value: "Em fase de elaboração" },
    ]
    return (
        <div>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label={"Cadastro CGRSS"} name={"cgrss"} value={estabelecimento.cgrss} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Início / Previsão Funcionamento"} type="date" name={"funcionamento"} value={estabelecimento.funcionamento} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.numeroMask} label={"Quantidade Funcionários"} name={"qtdFuncionarios"} value={estabelecimento.qtdFuncionarios} onChange={onChangeEstabelecimento} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"Condição de Funcionamento"} type="select" options={condicoesFuncionamento} name={"condicaoFuncionamento"} value={estabelecimento.condicaoFuncionamento} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Horário de Funcionamento"} type="select" options={condicoesHorarioFuncionamento} name={"horarioFuncionamento"} value={estabelecimento.horarioFuncionamento} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Dias de Funcionamento"} type="select" options={diasFuncionamento} multiple name={"diasFuncionamento"} value={estabelecimento.diasFuncionamento} onChange={onChangeEstabelecimento} />
                </Col>
            </Row>
            <Row>

                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label={"Nome da Empresa de Controle de Pragas"} name={"empresaControlePragas"} value={estabelecimento.empresaControlePragas} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="8">
                    <TextField mask={mascaras.numeroMask} maxLength={"30"} label={"Número Alvará Sanitário da Empresa de Controle de Pragas"} name={"empresaControlePragasAlvara"} value={estabelecimento.empresaControlePragasAlvara} onChange={onChangeEstabelecimento} />
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label={"Empresa Responsável pelo PCMSO"} name={"empresaPCMSO"} value={estabelecimento.empresaPCMSO} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="8">
                    <TextField maxLength={"300"} label={"Endereço da Empresa Responsável pelo PCMSO"} name={"enderecoEmpresaPCMSO"} value={estabelecimento.enderecoEmpresaPCMSO} onChange={onChangeEstabelecimento} />
                </Col>

            </Row>
            <Row>
                <Col md="12" lg="12">
                    <TextField label={"Possui Rotinas de Biossegurança, descritas e implantadas"} type="select" options={rotinaBioSeguranca} name={"RotinasBiosseguranca"} value={estabelecimento.RotinasBiosseguranca} onChange={onChangeEstabelecimento} />
                </Col>
            </Row>
            <h5 className='ms-4 mt-2'>Alvará Sanitário</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label={"Alvará Sanitário"} type="text" name={"alvaraSanitario"} value={estabelecimento.alvaraSanitario} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.numeroMask} maxLength={"30"} label={"Número"} type="text" name={"alvaraSanitarioNumero"} value={estabelecimento.alvaraSanitarioNumero} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Validade"} type="date" multiple name={"alvaraSanitarioValidade"} value={estabelecimento.alvaraSanitarioValidade} onChange={onChangeEstabelecimento} />
                </Col>
            </Row>
            <h5 className='ms-4 mt-2'>Licença Ambiental</h5>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label={"Licença Ambiental"} type="text" name={"licencaAmbiental"} value={estabelecimento.licencaAmbiental} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField mask={mascaras.numeroMask} maxLength={"30"} label={"Número"} type="text" name={"licencaAmbientalNumero"} value={estabelecimento.licencaAmbientalNumero} onChange={onChangeEstabelecimento} />
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Validade"} type="date" multiple name={"licencaAmbientalValidade"} value={estabelecimento.licencaAmbientalValidade} onChange={onChangeEstabelecimento} />
                </Col>
            </Row>
        </div>
    );
}